module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row center-block",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loginWithStoreNumber()
      }
    }
  }, [(_vm.error) ? _c('h4', {
    staticStyle: {
      "color": "yellow",
      "margin": "20px"
    }
  }, [_vm._v("\n    ERR: " + _vm._s(_vm.error) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "white",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14pt"
    }
  }, [_vm._v(_vm._s(_vm.$t('native_version')) + ": "), _c('b', [_vm._v(_vm._s(_vm.version))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14pt"
    }
  }, [_vm._v(_vm._s(_vm.$t('build_version')) + ": "), _c('b', [_vm._v(_vm._s(_vm.build))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14pt"
    }
  }, [_vm._v(_vm._s(_vm.$t('store_number')) + ": "), _c('b', [_vm._v(_vm._s(_vm.storeNumber || '??'))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14pt"
    }
  }, [_vm._v(_vm._s(_vm.$t('ip_address')) + ": "), _c('b', [_vm._v(_vm._s(_vm.ip))])])]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "center-block",
    staticStyle: {
      "margin-top": "2em",
      "width": "30%"
    }
  }, [_c('button', {
    staticClass: "btn btn-lg btn-block btn-success",
    staticStyle: {
      "height": "60px",
      "padding-top": "14px",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        return _vm.gotoBack()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left pull-left",
    staticStyle: {
      "margin": "2px -20px 0px 0px"
    }
  }), _vm._v(_vm._s(_vm.$t('back')))])]), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center-block",
    staticStyle: {
      "margin-top": "1em",
      "width": "30%"
    }
  }, [_c('button', {
    staticClass: "btn btn-block btn-lg btn-danger",
    staticStyle: {
      "height": "60px",
      "padding-top": "14px",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt pull-left",
    staticStyle: {
      "margin": "2px -20px 0px 0px"
    }
  }), _vm._v(_vm._s(_vm.$t('logout')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5b1f3897!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoDisplay.vue
// module id = 528
// module chunks = 2